<template>
    <vuestic-modal ref="filtro" :cancelClass="'none'" :okClass="'none'" @closeEvent="closeModal">
        <span slot="title">
            <span class="bold" style="color: #1c2d5a;">Adicionar Filtros</span>
        </span>
        <div>
            <div class="form-group col-sm-12">
                <div class="col-9 row">
                    <label class="col-12 bold" for="">Periodo de pagamento</label>
                    <input class="form-control col-5" type="date" v-model="filtro.dataInicio" :max="getDate()">
                    <span class="col-2 bold d-flex justify-content-center">à</span>
                    <input class="form-control col-5" type="date" v-model="filtro.dataFim" :max="getDate()">
                </div>
                <div class="col-3">
                    <label for="" class="bold">CPF do aluno</label>
                    <the-mask class="form-control" :mask="'###.###.###-##'" v-model="filtro.cpf" id="cpf_aluno"/>
                </div>
            </div>
            <div class="form-group col-sm-12">
                <div class="col-6 row">
                    <label class="col-12 bold" for="">Autoescola</label>
                    <model-select :options="selectCFC" v-model="filtro.autoescola" placeholder="Selecione uma"></model-select>
                    </select>
                </div>
                <div class="col-6">
                    <label for="" class="bold">Nome do aluno</label>
                    <input class="form-control" type="text" v-model="filtro.nome" @keyup.enter="search()">
                </div>
            </div>
            <div class="form-group col-sm-12 row">
                <div class="col-12">
                    <label class="col-12 bold" for="">Renach</label>
                </div>
                <div class="col-4">
                    <input class="form-control" type="text" v-model="filtro.renach" @keyup.enter="search()">
                </div>
                <div class="col-8 d-flex justify-content-end row">
                    <input class="form-control col-5 btn btn-lg btn-outline-danger mr-1 bold"
                        style="font-size: 10px; border: 1px solid;"
                        @click="discartSearch()"
                        type="button" value="Descartar filtros">
                    <input class="form-control col-5 btn btn-lg btn-info mr-1 bold"
                        style="font-size: 10px; background: #1c2d5a;"
                        @click="search()"
                        type="button" value="Salvar filtros">
                </div>
            </div>
        </div>
    </vuestic-modal>
</template>

<script>
import { ModelSelect } from 'vue-search-select'
    export default {
        components: {
            ModelSelect
        },
        props: {
            // open: Boolean
        },
        data() {
            return {
                selectCFC: [],
                selectedCFC: '',
                filtro: {
                    dataInicio: '',
                    dataFim:    '',
                    cpf:        '',
                    autoescola: '',
                    nome:       '',
                    renach:     '',
                },
                urlParam:   '',
            }
        },
        mounted() {
            this.loadCfc()
            this.openModal()
        },
        methods: {
            openModal() {
                this.$refs.filtro.open()
            },
            closeModal() {
                this.$emit('close')
            },
            search() {
                try {
                    this.urlParam   =   '';

                    !this.validateDate() ?
                        this.cleanDate()
                        :
                        this.urlParam   =   `?periodo[]=${this.filtro.dataInicio}&periodo[]=${this.filtro.dataFim}`;

                    if(this.urlParam == '')
                    {
                        this.validateForm()
                    }

                    this.urlParam == '' ?
                        this.urlParam   =   `?autoescola=${this.filtro.autoescola}&nome=${this.filtro.nome}&cpf=${this.filtro.cpf}&renach=${this.filtro.renach}`
                        :
                        this.urlParam   =   this.urlParam + `&autoescola=${this.filtro.autoescola}&nome=${this.filtro.nome}&cpf=${this.filtro.cpf}&renach=${this.filtro.renach}`
                    
                    this.$emit('search', this.urlParam);
                    this.closeModal();

                } catch (error) {
                    this.$toasted.show(error, {
                        position: 'top-right',
                    })
                }
            },
            discartSearch() {
                this.cleanValues()
                this.closeModal()
                this.$refs.filtro.close()
            },
            validateDate() {
                let dataI   =   this.filtro.dataInicio  != ''   ?   this.filtro.dataInicio  : null
                let dataF   =   this.filtro.dataFim     != ''   ?   this.filtro.dataFim     : null
                if(dataI && dataF)
                {
                    if (new Date(dataI) <= new Date(dataF)) {
                        return true;
                    }
                    throw 'Data inicial deve ser menor ou igual a final'
                }
                return false;
            },
            validateForm() {
                // Verificar se todos os campos estão vazios ou contêm apenas espaços
                const camposVazios = Object.values(this.filtro).every((valor) => {
                    // Remover espaços em branco
                    const valorSemEspacos = valor.trim();
                    // Verificar se o valor é vazio após remover os espaços
                    return valorSemEspacos === '';
                });
                if(camposVazios)
                {
                    throw 'Informe algo para a pesquisa!'
                }
            },
            cleanValues() {
                const clear =   Object.values(this.filtro).every((valor) => {
                    valor   =   '';
                })
                this.filtro =   clear;
            },
            cleanDate() {
                this.filtro.dataInicio  =   ''
                this.filtro.dataFim     =   ''
            },
            getDate(){
                let date    =   new Date()
                let day     =   String(date.getDate()).padStart(2, '0')
                let month   =   String(date.getMonth() + 1).padStart(2, '0')
                let year    =   date.getFullYear()
                return  year + '-' + month + '-' + day
            },
            loadCfc() {
                this.$http.get(process.env.VUE_APP_URL_API_V2 + '/autoescola/todas').then(response => {
                    response.data.dados.map(autoescolas =>{
                        if(autoescolas.nome_fantasia !== 'TEwSTE')
                        {
                            let sindicato = autoescolas.sindicato ? 'SINDICATO' : '';
                            this.selectCFC.push({
                                value: autoescolas.tenant_schema,
                                text: autoescolas.nome_fantasia+' | '+ sindicato,
                            })
                        }
                    })
                }).catch(function (error) {
                    this.$toasted.show('Erro!'+ error, {
                        position: 'top-right',
                    });
                })
            }
        },
    }
</script>

<style scoped>
input[type=text] {
  border: 1px solid gray;
  border-radius: 4px;
}
input[type=date] {
  border: none;
  border-bottom: 1px solid gray;
}
.bold {
  font-weight: bold;
}
</style>